import { PresentationBundleKind } from '@/types/schema';

import { BundleSaveDescriptor } from '../presentationSave.types';
import { createGeneratedBundleCardDescriptor } from './generatedBundleCardDescriptor';

export const trustOverviewBundleDescriptor: BundleSaveDescriptor =
  createGeneratedBundleCardDescriptor({
    kind: PresentationBundleKind.TrustOverviewBundle,
    field: 'trustOverviewBundleConfiguration',
    read: (bundle) => {
      const config = bundle.trustOverviewBundleConfiguration;
      if (!config) return undefined;
      return {
        id: config.id,
        displayName: config.displayName,
        itemsPerPage: config.itemsPerPage,
        cards: config.trusts.map((trust) => ({
          id: trust.id,
          name: trust.label,
          items: trust.items,
        })),
      };
    },
  });
